// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"127":"c16940da","607":"8db15062","796":"55287f2f"}[chunkId] + ".js";
};